module.exports = __webpack_public_path__ + "odinstatic/v5.0.2/media/consigner.d065bc68.svg";